import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manutencao',
  template: `
    <div class="wrapper">
      <!-- <button mat-icon-button matDialogClose class="a">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.2426 6.34314L12 10.5858L7.75736 6.34314L6.34315 7.75735L10.5858 12L6.34315 16.2426L7.75736 17.6568L12 13.4142L16.2426 17.6568L17.6569 16.2426L13.4142 12L17.6569 7.75735L16.2426 6.34314Z"
          />
        </svg>
      </button> -->

      <p>Portal em manutenção</p>
      <!-- <p>Consulta prévia</p>
      <p>Estamos em manutenção.</p> -->
    </div>
  `,
  styles: [
    `
      :host {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .a {
        align-self: flex-end;
      }

      .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      p {
        font-size: 20px;
        margin: 0 0 20px 0;
        text-align: center;
      }
    `,
  ],
})
export class ManutencaoComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  toOvi() {
    const isTopocartDev = environment['isTopocartDev'];
    let city: string | null = null;
    
    if (isTopocartDev) {
      const url = window.location.pathname;
      const urlMatch = url.match(/\/([^/]+)\/(icad|ovi)\//);
      if (urlMatch) {
        city = urlMatch[1];
      } else {
        const pathSegments = url.split('/').filter(segment => segment.length > 0);
        if (pathSegments.length > 0) {
          city = pathSegments[0];
        }
      }
    }

    if (isTopocartDev && city) {
      this.router.navigate([city, 'ovi']);
    } else {
      this.router.navigate(['ovi']);
    }
  }
}
